import { isAxiosError } from 'axios';
import axiosInstance from '../../utility/axiosInstance';

// types and state
import {
  setTecnicalSkill,
  createTecnicalSkill,
  updateTecnicalSkill,
  setLoading,
  setUpdate
} from '@/store/slices/technical_skill';

// notification
import { openNotification } from '@/components/alerts/notify';
import { AppDispatch } from '@/store';

export const get_technical_skills = async (dispatch: AppDispatch) => {
  dispatch(setLoading());
  try {
    const response = await axiosInstance.get('/get-technical-skills');

    dispatch(setTecnicalSkill(response.data));
  } catch (err) {
    if (isAxiosError(err)) dispatch(setTecnicalSkill([]));
  }
  dispatch(setLoading());
};

type ICreateData = { name: string };
export const create_technical_skills = async (
  dispatch: AppDispatch,
  data: ICreateData
) => {
  dispatch(setUpdate());
  try {
    const response = await axiosInstance.post('/create-technical-skill', data);

    openNotification({ status: 'success', message: response.data?.message });
    dispatch(createTecnicalSkill(response.data?.data));
  } catch (err) {
    if (isAxiosError(err)) {
    }
  }
  dispatch(setUpdate());
};

type IUpdateData = { name: string; id: string };
export const update_technical_skills = async (
  dispatch: AppDispatch,
  data: IUpdateData
) => {
  dispatch(setUpdate());
  try {
    const response = await axiosInstance.patch('/update-technical-skill', data);

    openNotification({ status: 'success', message: response.data?.message });
    dispatch(updateTecnicalSkill(response.data?.data));
  } catch (err) {
    if (isAxiosError(err)) {
      openNotification({
        status: 'success',
        message: err?.response?.data?.message
      });
    }
  }
  dispatch(setUpdate());
};
